import supplierApi from '../../../../api/supplier';
import optionApi from '../../../../api/option';

const defaultState = () => ({
	supplierResults: [],
	supplierProductResults: [],
	supplierPagination: '',
	responSukses: '',
	konfirmResponse: {},
	supplier: [],
	product: [],
	alertMultiple: [],
	alert: ''
});

const state = defaultState();

const getters = {

};

const mutations = {

	listSupplier(state, data) {
		state.supplierResults = data.data.map((el) => {
			if (el.supplier_is_active == "active") {
				el.supplier_is_active = true
			} else {
				el.supplier_is_active = false
			}
			return el
		});
		state.supplierPagination = data.pagination;
	},
	listSupplierProduct(state, data) {
		state.supplierProductResults = data.data;
		state.supplierPagination = data.pagination;
	},
	listOptionProduct(state, data) {
		state.product = data;
	},
	listOptionSupplier(state, data) {
		state.supplier = data;
	},
	konfirmasiSukses(state, data) {
		state.konfirmResponse = {};
		state.responSukses = data;
	},
	saveConfirmResponse(state, data) {
		state.konfirmResponse = data;
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataSupplier(state) {
		Object.assign(state, defaultState());
	},
};

const actions = {
	getSupplier({ commit }, param) {
		supplierApi.getDataSupplier(param).then(({ data: { data } }) => {
			commit('listSupplier', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('listSupplier', { data: [], pagination: {} });
		});
	},
	async exportSupplier({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await supplierApi.exportSupplier(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data supplier'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async addSupplier({ dispatch, commit }, value) {
		commit("konfirmasiSukses", '');
		await supplierApi.addSupplier(value).then( res => {
			const data = res.data;
			dispatch('success', data)
			commit("konfirmasiSukses", data);
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menambah Supplier'
			}, { root: true });
		});
	},
	async updateSupplier({ dispatch, commit }, value) {
		commit("konfirmasiSukses", '');
		await supplierApi.updateSupplier(value).then( res => {
			const data = res.data;
			dispatch('success', data)
			commit("konfirmasiSukses", data);
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal mengubah Supplier'
			}, { root: true });
		});
	},
	async deleteSupplier({ dispatch, commit }, value) {
		commit("konfirmasiSukses", '');
		await supplierApi.deleteSupplier({ id: value }).then( res => {
			const data = res.data;
			dispatch('success', data)
			commit("konfirmasiSukses", data);
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menghapus Supplier'
			}, { root: true });
		});
	},
	async statusSupplier({ dispatch, commit }, value) {
		commit("konfirmasiSukses", '');
		await supplierApi.statusSupllier(value).then( res => {
			const data = res.data;
			dispatch('success', data)
			commit("konfirmasiSukses", data);
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal mengubah status Supplier'
			}, { root: true });
		});
	},
	getSupplierProduct({ commit }, param) {
		supplierApi.getDataSupplierProduct(param).then(({ data: { data } }) => {
			commit('listSupplierProduct', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('listSupplierProduct', { data: [], pagination: {} });
		});
	},
	async addSupplierProduct({ dispatch, commit }, value) {
		commit("konfirmasiSukses", '');
		await supplierApi.addSupplierProduct(value).then( res => {
			const data = res.data;
			dispatch('success', data)
			commit("konfirmasiSukses", data);
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menambah Produk Supplier'
			}, { root: true });
		});
	},
	async updateSupplierProduct({ dispatch, commit }, value) {
		commit("konfirmasiSukses", '');
		await supplierApi.updateSupplierProduct(value).then( res => {
			const data = res.data;
			dispatch('success', data)
			commit("konfirmasiSukses", data);
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal mengubah Produk Supplier'
			}, { root: true });
		});
	},
	async deleteSupplierProduct({ dispatch, commit }, value) {
		commit("konfirmasiSukses", '');
		await supplierApi.deleteSupplierProduct(value).then( res => {
			const data = res.data;
			dispatch('success', data)
			commit("konfirmasiSukses", data);
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menghapus Produk Supplier'
			}, { root: true });
		});
	},
	getProductOption({ commit }) {
		optionApi.getOptionProduct().then(({ data: { data: { results } } }) => {
			commit('listOptionProduct', results);
		}).catch(() => {
			commit('listOptionProduct', []);
		});
	},
	getSupplierOption({ commit }) {
		return new Promise((resolve) => {
			optionApi.getOptionSupplier().then(({ data: { data: { results } } }) => {
				commit('listOptionSupplier', results);
				resolve(results)
			}).catch(() => {
				commit('listOptionSupplier', []);
				resolve([])
			});
		})
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('saveConfirmResponse', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};